// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;He asked of you life and you gave it him,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;length of days, for ever and ever.<br> </p> </div></div>";
// Exports
module.exports = code;